import CopyButton from "@components/buttons/CopyButton";
import React from "react";

interface LabelRowProps {
  label: string;
  value?: string;
  isCopy?: boolean;
  valueComp?: React.ReactNode;
}
const LabelRow: React.FC<LabelRowProps> = ({
  label,
  value,
  isCopy = false,
  valueComp,
}) => {
  return (
    <div className="flex flex-row justify-between items-center">
      <span className="font-medium text-[12px] w-[40%] text-text-label">
        {label}
      </span>
      {valueComp ? (
        valueComp
      ) : (
        <div className="flex flex-row items-center gap-[4px]">
          <span className="font-medium text-[12px] text-text-base truncate p-0 m-0">
            {value}
          </span>
          {isCopy && (
            <CopyButton
              copyText={value || ""}
              copyMessage={`${label} copied to clipboard`}
              fillColor="bg-border-button-secondary"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default LabelRow;
